export function normalizePeriod(period) {
  return {
    id: period?.id || period?._id || "",
    name: period?.name || "",
    site: period?.site || "",
    startAt: period?.startAt || "",
    endAt: period?.endAt || "",
    shifts: Array.isArray(period?.shifts)
      ? period.shifts.map((shift) => ({
          id: shift?.id || shift?._id || "",
          name: shift?.name || "",
          days: Array.isArray(shift?.days)
            ? shift.days.map((day) => ({
                dayOfWeek: day?.dayOfWeek,
                startTime: day?.startTime || "",
                endTime: day?.endTime || "",
              }))
            : [],
        }))
      : [],
  };
}

export function normalizePeriodsResponse(response) {
  const status = response?.status;
  const payload = response?.data;

  if (status === 204 || !payload) {
    return [];
  }

  const rows = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.rows)
      ? payload.rows
      : Array.isArray(payload)
        ? payload
        : [];

  return rows.map(normalizePeriod);
}

export function upsertPeriod(periods, period) {
  const normalized = normalizePeriod(period);
  const index = periods.findIndex((item) => item.id === normalized.id);

  if (index === -1) {
    return [...periods, normalized];
  }

  const next = [...periods];
  next[index] = normalized;
  return next;
}

export function removePeriod(periods, periodId) {
  return periods.filter((period) => period.id !== periodId);
}

export function mergeShiftMutationResponse(periods, periodId, mutationResponse) {
  const shifts = Array.isArray(mutationResponse?.shifts)
    ? mutationResponse.shifts.map((shift) => ({
        id: shift?.id || shift?._id || "",
        name: shift?.name || "",
        days: Array.isArray(shift?.days)
          ? shift.days.map((day) => ({
              dayOfWeek: day?.dayOfWeek,
              startTime: day?.startTime || "",
              endTime: day?.endTime || "",
            }))
          : [],
      }))
    : [];

  return periods.map((period) => {
    if (period.id !== periodId) {
      return period;
    }

    return {
      ...period,
      shifts,
    };
  });
}

export function removeShiftFromPeriod(periods, periodId, shiftId) {
  return periods.map((period) => {
    if (period.id !== periodId) {
      return period;
    }

    return {
      ...period,
      shifts: period.shifts.filter((shift) => shift.id !== shiftId),
    };
  });
}
